var render, staticRenderFns
import script from "./feather.vue?vue&type=script&lang=js&"
export * from "./feather.vue?vue&type=script&lang=js&"
import style0 from "./feather.vue?vue&type=style&index=0&id=2d14a195&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d14a195",
  null
  
)

export default component.exports